import { useNavigate } from "react-router-dom";
import { questions } from "../data/questions";
import { useTestSession } from "../context/TestSessionContext";

function HomePage() {
  const navigate = useNavigate();
  const { startTest } = useTestSession();

  const handleStart = () => {
    startTest(questions.length);
    navigate("/test");
  };

  return (
    <main className="min-h-screen bg-gradient-animal text-gray-900">
      <section className="mx-auto flex min-h-screen max-w-3xl items-center px-6 py-12">
        <div className="w-full rounded-3xl bg-white/95 p-8 shadow-xl md:p-10">
          <p className="mb-3 inline-block rounded-full bg-orange-100 px-3 py-1 text-xs font-semibold text-orange-700">
            趣味测试 | 约 5 分钟完成
          </p>
          <h1 className="mb-3 text-3xl font-bold md:text-4xl">
            你的动物人格是哪一型？
          </h1>
          <p className="mb-8 leading-7 text-gray-600">
            通过 20 道心理学场景题，识别你的动物人格、优势倾向与成长建议。
          </p>
          <button
            onClick={handleStart}
            className="rounded-xl bg-fox-orange px-6 py-3 font-semibold text-white transition hover:opacity-90"
          >
            开始测试
          </button>
        </div>
      </section>
    </main>
  );
}

export default HomePage;
